export default {"src":"/_next/static/media/fi.cda1a2cf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};